var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailNotOpenedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.729 17.832C3.25353 17.832 2.84663 17.6628 2.50833 17.3245C2.16944 16.9857 2 16.5785 2 16.103V5.729C2 5.25353 2.16944 4.84663 2.50833 4.50833C2.84663 4.16944 3.25353 4 3.729 4H17.561C18.0365 4 18.4437 4.16944 18.7825 4.50833C19.1208 4.84663 19.29 5.25353 19.29 5.729V16.103C19.29 16.5785 19.1208 16.9857 18.7825 17.3245C18.4437 17.6628 18.0365 17.832 17.561 17.832H3.729ZM10.645 11.6292C10.717 11.6292 10.7925 11.6183 10.8715 11.5964C10.951 11.575 11.0268 11.5428 11.0989 11.4995L17.2152 7.67412C17.3305 7.60208 17.4169 7.51218 17.4746 7.4044C17.5322 7.29605 17.561 7.17704 17.561 7.04736C17.561 6.7592 17.4385 6.54307 17.1936 6.39899C16.9486 6.2549 16.6965 6.26211 16.4372 6.4206L10.645 10.0515L4.85285 6.4206C4.5935 6.26211 4.34135 6.25836 4.09641 6.40936C3.85147 6.56094 3.729 6.7736 3.729 7.04736C3.729 7.19145 3.75782 7.31737 3.81545 7.42515C3.87308 7.5335 3.95953 7.61649 4.0748 7.67412L10.1911 11.4995C10.2632 11.5428 10.339 11.575 10.4185 11.5964C10.4975 11.6183 10.573 11.6292 10.645 11.6292Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNotOpenedIcon);
export default __webpack_public_path__ + "static/media/MailNotOpenedIcon.0f86dae9e0c49e2ef83cf580de58a350.svg";
export { ForwardRef as ReactComponent };